<template>
  <div class="preview">
    <div class="header no-print">
      <div class="back button" @click="goToHome">
        <div class="icon-container">
          <div class="logo"></div>
        </div>
        <div class="title">WASHI</div>
      </div>
      <div class="buttons-group">
        <div class="button" title="PREVIEW (Debug)" @click="downloadPdf">
          <div class="icon-container">
            <i class="material-icons icon">description</i>
          </div>
          <div v-if="downloading" class="title">Downloading</div>
          <div v-else class="title">Save as PDF</div>
        </div>
        <div class="button" title="PREVIEW (Debug)" @click="goToEditor">
          <div class="icon-container">
            <i class="material-icons icon">description</i>
          </div>
          <div class="title">Editor</div>
        </div>
      </div>
    </div>
    <ResumeRenderer v-if="resume" :resume="resume" :items="items" :is-printing="true" />
  </div>
</template>

<script>
import ResumeRenderer from '@/components/ResumeRenderer';
import { mapGetters } from 'vuex';

export default {
  name: 'PreviewView',
  components: {
    ResumeRenderer,
  },
  data() {
    return {
      downloading: false,
    };
  },
  computed: {
    ...mapGetters(['currentResume']),
    resume() {
      return this.currentResume;
    },
    items() {
      if (this.resume) return this.resume.items;
      return [];
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('resumes.getCurrent', this.$route.params.id);
    } catch (e) {
      console.error("can't get resume");
    }
    window.document.title = `${this.resume.candidate.firstname}-${this.resume.candidate.lastname}`;
  },
  methods: {
    goToHome() {
      if (this.$auth.isLogged()) {
        this.$router.push({ name: 'dashboard' });
      } else {
        this.$router.push({ name: 'home' });
      }
    },
    goToEditor() {
      this.$router.push({ name: 'editor' });
    },
    async downloadPdf() {
      if (this.downloading) return;
      this.downloading = true;
      try {
        const file = await this.$store.dispatch('resumes.downloadPdf', this.$route.params.id);

        const link = document.createElement('a');
        link.download = file.filename;
        link.target = '_blank';
        link.href = file.url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        if (e.response && e.response.status === 429) {
          alert('quota exceded for PDF generating');
        } else {
          alert(JSON.stringify(e));
        }
        console.error(e);
      }
      this.downloading = false;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

@page {
  size: A4;
  margin: 0;
}

.preview {
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  position: fixed;
  z-index: 100;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: app.$topbar-height;
  padding: 0 16px;
  width: 100%;
  background: #f2f2f2;
  border-bottom: solid 1px #dadada;
  box-sizing: border-box;

  .logo {
    width: 32px;
    height: 32px;

    font-weight: 900;
    color: colors.$main-color;
    font-size: 24px;
    background-image: url('../assets/Logo_Washi_Small.svg?file-css');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 8px;
    cursor: pointer;

    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 32px;
      width: 48px;
      padding: 0 4px;
      font-size: 14px;
      color: #7d7d7d;
      background: #fafafa;
      box-shadow:
        0 0 0 0.5px rgba(125, 125, 125, 0.5),
        0 1px 2px -1px #7d7d7d;
      border-radius: 4px;
      box-sizing: border-box;
      transition: 0.2s ease-in-out;

      .icon {
        font-size: 20px;
        color: #434143;
        transition: 0.2s;
      }
    }

    .title {
      color: #434143;
      width: 100%;
      margin: 4px 0 0;
      text-align: center;
      font-size: 12px;
    }

    &:hover .icon-container {
      transform: scale(1.05);

      .icon {
        color: colors.$main-color;
      }
    }

    &:active .icon-container {
      transform: scale(0.95);

      .icon {
        color: colors.$main-color;
      }
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .buttons-group {
    display: flex;
  }
}
</style>
